import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

// Flutter logo SVG icon
const FlutterLogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 125"
    width="80"
    height="80"
    aria-label="Flutter Dev Board logo"
  >
    {/* Flutter "F" chevron shape */}
    <polygon points="10,60 40,30 55,30 25,60" fill="#54C5F8" />
    <polygon points="25,60 55,30 70,30 55,60 70,90 55,90" fill="#01579B" />
    <polygon points="55,60 70,90 55,90 40,75" fill="#29B6F6" />
  </svg>
);

// Flutter Docs icon (book)
const FlutterDocsIcon = (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

// pub.dev icon (package box)
const PubDevIcon = (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

// Widget catalog icon (grid)
const WidgetCatalogIcon = (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        Export, open files, preferences, and Flutter resources...
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        {/* Custom Flutter Logo */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
            marginBottom: "4px",
          }}
        >
          <FlutterLogoIcon />
          <span
            style={{
              fontSize: "1.1rem",
              fontWeight: 700,
              color: "#0553B1",
              letterSpacing: "0.05em",
              fontFamily: "sans-serif",
            }}
          >
            Flutter Dev Board
          </span>
        </div>

        <WelcomeScreen.Center.Heading>
          Design • Architect • Ship
          <br />
          <span style={{ fontSize: "0.85em", fontWeight: 400, opacity: 0.75 }}>
            Flutter &amp; Dart diagramming workspace
          </span>
        </WelcomeScreen.Center.Heading>

        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
          {/* Flutter Docs */}
          <WelcomeScreen.Center.MenuItemLink
            href="https://docs.flutter.dev"
            shortcut={null}
            icon={FlutterDocsIcon}
          >
            Flutter Documentation
          </WelcomeScreen.Center.MenuItemLink>
          {/* pub.dev */}
          <WelcomeScreen.Center.MenuItemLink
            href="https://pub.dev"
            shortcut={null}
            icon={PubDevIcon}
          >
            pub.dev — Package Registry
          </WelcomeScreen.Center.MenuItemLink>
          {/* Widget Catalog */}
          <WelcomeScreen.Center.MenuItemLink
            href="https://docs.flutter.dev/reference/widgets"
            shortcut={null}
            icon={WidgetCatalogIcon}
          >
            Flutter Widget Catalog
          </WelcomeScreen.Center.MenuItemLink>
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
